module.exports = __webpack_public_path__ + "img/check_yellow.735dec12.svg";